import { render, staticRenderFns } from "./coach-form-page.vue?vue&type=template&id=0b54c29f&"
import script from "./coach-form-page.vue?vue&type=script&lang=js&"
export * from "./coach-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports